import React from "react";
import {Helmet} from 'react-helmet'
import '../../application/components/thankYou.css'



export default function ThankYou() {

    return (
        <>
		
			<Helmet>
				<title> Uplyft Capital Onboarding Merchant | Thank-You </title>
			</Helmet>
			<main className="page__inner mt-5" role="main">
				<div className="ty container">
					<div className="">
						<div className="ty__left">
                            <div className="">
								<h1>Thank you!</h1>
                                <p>Thank you for your interest in our syndication program!&nbsp;</p>
                                <p>We are processing your inquiry and will call you shortly to say hello.&nbsp;</p>
                            </div>
							<div className="ty__footer-text">
                                <h2>Have questions?</h2>
                                <p>Feel free to call us, we’ll be happy to assist you. <a href="tel:1 800 515-7531"><strong>1 (800) 515-7531</strong></a></p>
							</div>
							<div className="ty__buttons">
								<a href="https://uplyftcapital.com" className="btn btn-primary ">Back to Site</a>
							</div>
						</div>
						<div className="ty__right js-is-seen mobile-none" style={{ display: 'flex', justifyContent: 'center' }}>
	
						</div>
					</div>
				</div>
            </main>
        </>

    );
}
